import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { KeyRound, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!token) { toast.error("Missing reset token"); return; }
    if (password !== confirm) { toast.error("Passwords do not match"); return; }
    if (password.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => nav("/employer-portal/login"), 2200);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed — your link may have expired.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="text-xs uppercase tracking-[0.2em] text-ink font-semibold">← Railway Careers UK</Link>
        <div className="mt-4 bg-card border border-border rounded-lg p-8">
          {done ? (
            <div className="text-center" data-testid="reset-done">
              <CheckCircle2 className="w-12 h-12 text-lime-600 mx-auto" />
              <h1 className="font-display font-extrabold text-ink text-2xl mt-5">Password updated</h1>
              <p className="mt-3 text-sm text-muted-foreground">Redirecting you to sign in…</p>
            </div>
          ) : (
            <form onSubmit={submit} data-testid="reset-form">
              <KeyRound className="w-10 h-10 text-amber-600" />
              <h1 className="font-display font-extrabold text-ink text-2xl mt-4">Choose a new password</h1>
              <p className="mt-2 text-sm text-muted-foreground">Pick something at least 8 characters long.</p>
              <div className="mt-6">
                <Label>New password</Label>
                <Input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" data-testid="reset-password" />
              </div>
              <div className="mt-4">
                <Label>Confirm password</Label>
                <Input required type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1" data-testid="reset-confirm" />
              </div>
              <Button type="submit" disabled={loading} className="w-full mt-5 bg-navy text-bone hover:bg-lime-600 hover:text-ink font-semibold" data-testid="reset-submit">
                {loading ? "Updating…" : "Update password"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
